import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getMonthlyPayments } from 'features/statement/statementActions';
import {
  selectMonthlyPayments,
  selectStatementLoading,
} from 'features/statement/statementSlice';
import MuiTable from 'modules/billing/components/muiTable/MuiTable';
import {
  MonthColor,
  MonthTitle,
  MonthView,
  MonthWrapper,
} from 'modules/billing/pages/comparison/charts/Charts.styles';
import { Cell, Label, Pie, PieChart, ResponsiveContainer } from 'recharts';

import {
  Title,
  ViewContainer,
} from '../../../modules/billing/pages/subscribers/Subscribers.styles';
import PaymentReportFilters from './PaymentReportFilters';
import {
  ChatRow,
  FilterContainerPayment,
} from './PaymentReportFilters/PaymentReportFilters.styles';
import { usePaymentReportSearchParams } from './usePaymentReportSearchParams';

const PaymentReport = () => {
  const { searchData: paymentSearchData, setPaymentReportSearchData } =
    usePaymentReportSearchParams();

  const handlePageChange = (page) => {
    setPaymentReportSearchData({ page: page - 1 });
  };

  const data = useSelector(selectMonthlyPayments);
  const loading = useSelector(selectStatementLoading);

  const dispatch = useDispatch();

  const columns = [
    { id: 'year', label: 'Տարի' },
    {
      id: 'month',
      label: 'Ամիս',
    },
    { id: 'b2b', label: 'B2B' },
    { id: 'b2c', label: 'B2C' },
    { id: 'total', label: 'Ընդհանուր' },
  ];

  const hasAllFilters = paymentSearchData.fromYear !== '' && paymentSearchData.toYear !== '';

  const pieData = [
    { name: 'B2B', value: data.totalB2b || 0, color: '#2D6CDF' },
    { name: 'B2C', value: data.totalB2c || 0, color: '#FF6A00' },
  ];

  const formattedTotal = data.totalAmount?.toLocaleString('hy-AM');

  useEffect(() => {
    dispatch(getMonthlyPayments(paymentSearchData));
  }, [paymentSearchData, dispatch]);

  return (
    <>
      <ViewContainer>
        <PaymentReportFilters />
        {hasAllFilters && (
          <FilterContainerPayment>
            {!loading.monthlyPayments && (
              <Title className="inline_title ">
                Ընդհանուր վճարված գումարը՝ {''}
                {Number(data.totalAmount).toLocaleString('hy-AM')}
              </Title>
            )}
          </FilterContainerPayment>
        )}
        {hasAllFilters && (
          <ChatRow>
            <div style={{ width: '650px', height: 'auto' }}>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={80}
                    outerRadius={130}
                    fill="#8884d8"
                    label={({ value, cx, cy, midAngle, innerRadius, outerRadius }) => {
                      const RADIAN = Math.PI / 180;
                      const radius = outerRadius + 25;
                      const x = cx + radius * Math.cos(-midAngle * RADIAN);
                      const y = cy + radius * Math.sin(-midAngle * RADIAN);

                      const formattedValue = value?.toLocaleString('hy-AM');

                      return (
                        <text
                          x={x}
                          y={y}
                          fill="#333"
                          textAnchor={x > cx ? 'start' : 'end'}
                          dominantBaseline="central"
                          fontSize={13}
                          fontWeight="700"
                        >
                          {formattedValue}
                        </text>
                      );
                    }}
                  >
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <Label
                      value={formattedTotal}
                      position="center"
                      fontSize={16}
                      fontWeight="600"
                      fill="#6C757D"
                    />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <MonthWrapper>
              <MonthView>
                <MonthColor />
                <MonthTitle>B2C</MonthTitle>
              </MonthView>
              <MonthView>
                <MonthColor $isNext={true} />
                <MonthTitle>B2B</MonthTitle>
              </MonthView>
            </MonthWrapper>
          </ChatRow>
        )}
        <MuiTable
          rowCount={paymentSearchData.size}
          data={data?.data?.content || []}
          loading={loading.monthlyPayments}
          columns={columns}
          totalPages={data.data?.totalPages}
          currentPage={paymentSearchData.page + 1}
          handlePageChange={handlePageChange}
          dataCount={data.data?.totalElements}
        />
        {/* {isMobile && (
          <MobileList
            columns={mobileColumns}
            data={data}
            expandable={renderExpandableContent}
            onPaginationChange={handlePageChange}
            currentPage={searchData.page + 1}
            loading={isLoading.invoices}
            totalPages={pagesCount}
            handleSortClick={handleSortClick}
            sortable={true}
          />
        )} */}
      </ViewContainer>
    </>
  );
};

export default PaymentReport;
